<template>
  <div class="decay-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>详见下方原理说明</div>
    </div>

    <div class="main-stage">
      <div class="atom-container">
        <div v-for="atom in atoms" :key="atom.id" class="atom" :class="{ decayed: atom.decayed }" :style="atomStyle(atom)">
           <div class="nucleus" v-if="!atom.decayed"></div>
           <div class="fragment" v-else></div>
        </div>
      </div>
      
      <div class="chart">
        <div class="chart-bar" :style="{ height: (remainingRatio * 100) + '%' }">
           <span class="label">剩余: {{ (remainingRatio * 100).toFixed(1) }}%</span>
        </div>
      </div>
    </div>

    <div class="decay-info">
      <p v-latex>半衰期 ($T_{1/2}$): 当大量原子经一个半衰期后，约有一半发生衰变。</p>
      <p v-latex>衰变规律: $N = N_0(1/2)^{t/T}$</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NuclearDecayViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      atoms: Array.from({length: 100}, (_, i) => ({ id: i, decayed: false, x: Math.random()*100, y: Math.random()*100 })),
      time: 0,
      halfLife: 5 // 假设 5 秒为一个半衰期
    }
  },
  computed: {
    remainingRatio() {
      return this.atoms.filter(a => !a.decayed).length / 100;
    }
  },
  mounted() {
    this.timer = setInterval(this.tick, 1000);
  },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    tick() {
      this.time++;
      // 每个未衰变的原子每秒有随机概率衰变
      // 概率 p = 1 - (0.5)^(1/halfLife)
      const prob = 1 - Math.pow(0.5, 1/this.halfLife);
      this.atoms.forEach(a => {
        if (!a.decayed && Math.random() < prob) {
          a.decayed = true;
        }
      });
    },
    reset() {
      this.time = 0;
      this.atoms.forEach(a => a.decayed = false);
    },
    atomStyle(a) {
      return { left: a.x + '%', top: a.y + '%' };
    }
  }
}
</script>

<style scoped lang="scss">
.decay-viz { width: 100%; color: #fff; display: flex; flex-direction: column; gap: 10px; }
.viz-header { display: flex; justify-content: space-between; padding: 10px; background: rgba(255,255,255,0.05); }
.main-stage { display: flex; height: 300px; gap: 20px; }
.atom-container { flex: 1; background: #000; position: relative; border-radius: 8px; border: 1px solid #333; }
.atom { position: absolute; width: 8px; height: 8px; transition: all 0.5s; }
.nucleus { width: 100%; height: 100%; background: #ff4757; border-radius: 50%; box-shadow: 0 0 5px #ff4757; }
.decayed { opacity: 0.3; transform: scale(0.6); }
.fragment { width: 4px; height: 4px; background: #2ed573; border-radius: 50%; }

.chart { width: 60px; background: #222; position: relative; border-radius: 4px; overflow: hidden; }
.chart-bar { position: absolute; bottom: 0; width: 100%; background: linear-gradient(to top, #ff4757, #ff6b6b); transition: height 1s; .label { position: absolute; top: -20px; left: 0; font-size: 8px; white-space: nowrap; } }

.decay-info { padding: 10px; font-size: 0.8rem; color: #888; background: rgba(255, 71, 87, 0.05); }
</style>
